<template>
  <StackedListRowTwoColumnRightCentered :name="legName" :icon="false">
    <template #left-bottom>
      <StackedListRowIconWithText :icon="CalendarIcon">{{
        props.leg.formatted_departure_date
      }}</StackedListRowIconWithText>
      <StackedListRowIconWithText
        class="mt-2 sm:mt-0 sm:ml-4"
        :icon="ClockIcon"
        >{{ props.leg.formatted_travel_time }}</StackedListRowIconWithText
      >
      <div
        v-if="chips.length"
        class="mt-2 flex flex-wrap items-center gap-1 sm:mt-0 sm:ml-4"
        :title="crewSummary(props.leg.pilots)"
      >
        <span
          v-for="(chip, index) in chips"
          :key="index"
          class="rounded px-1 text-xs font-semibold leading-4"
          :class="chip.classes"
          :title="chip.title"
          >{{ chip.text }}</span
        >
      </div>
    </template>
    <template #right>
      <div class="flex mr-1">
        <SpanText class="flex" color="text-gray-600" font="text-sm">
          {{ props.leg.departure_airport.display_code }}
          <ArrowSmRightIcon class="h-4 w-4 my-auto" />
          {{ props.leg.arrival_airport.display_code }}
        </SpanText>
      </div>
    </template>
  </StackedListRowTwoColumnRightCentered>
</template>

<script setup>
import { CalendarIcon, ArrowSmRightIcon, ClockIcon } from '@heroicons/vue/solid'
import SpanText from '@/Common/Text/SpanText.vue'
import { computed } from 'vue'
import StackedListRowTwoColumnRightCentered from '@/Common/Lists/StackedLists/Rows/StackedListRowTwoColumnRightCentered.vue'
import StackedListRowIconWithText from '@/Common/Lists/StackedLists/Rows/Parts/StackedListRowIconWithText.vue'
import { getLegDisplayName } from './Common'
import { crewChips, crewSummary } from '../Calendar/pilotColors'

const props = defineProps({
  leg: Object,
  // Pilots and managers also see red chips for a missing PIC or SIC
  showCrewWarnings: Boolean,
})

const legName = computed(() => getLegDisplayName(props.leg))

const chips = computed(() =>
  crewChips(props.leg.pilots, props.showCrewWarnings)
)
</script>
